export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_13.87e0ad28.jpg";